import makeStyles from '@mui/styles/makeStyles';

import { borderColor, darkGray, surfaceSecondary, teal900, textPrimary } from '@/theme/colors';

export const useStyles = makeStyles({
  confirmationContent: {
    padding: '32px 24px',
    textAlign: 'center',
  },
  confirmationIcon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#D1FAE5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  confirmationTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: textPrimary,
    margin: '0 0 8px 0',
  },
  confirmationSubtitle: {
    fontSize: 14,
    color: darkGray,
    margin: '0 0 24px 0',
  },
  whatsNextBox: {
    backgroundColor: surfaceSecondary,
    border: `1px solid ${borderColor}`,
    borderRadius: 8,
    padding: 16,
    textAlign: 'left',
    marginBottom: 16,
  },
  whatsNextTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: textPrimary,
    margin: '0 0 12px 0',
  },
  whatsNextList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  whatsNextItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 8,
    fontSize: 14,
    color: darkGray,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  whatsNextCheckmark: {
    color: 'var(--brandPrimary)',
    flexShrink: 0,
    marginTop: 2,
  },
  trialStartedBanner: {
    backgroundColor: '#F0FDFA',
    border: '1px solid #99F6E4',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
  },
  trialStartedText: {
    fontSize: 14,
    color: '#0F766E',
    margin: 0,
    textAlign: 'left',
  },
  dashboardButton: {
    width: '100%',
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '8px 24px !important',
    minHeight: '36px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#004544',
    },
  },
  confirmationFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 40px',
    borderTop: `1px solid ${borderColor}`,
    backgroundColor: surfaceSecondary,
  },
});
